import { useEffect, useContext } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import AuthService from "services/auth-service";
import { AuthContext } from "context";

function OAuthCallback() {
  const { provider } = useParams(); // ✅ Correct source of provider
  const location = useLocation();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  useEffect(() => {
    const handleCallback = async () => {
      const queryParams = new URLSearchParams(location.search);
      const code = queryParams.get("code");
      const error = queryParams.get("error");

      if (error) {
        console.error("OAuth error:", error);
        return navigate("/auth/login");
      }

      if (!code || !provider) {
        console.error("Missing OAuth code or provider.");
        return navigate("/auth/login");
      }

      try {
        const response = await AuthService.handleFederatedCallback(provider, code);
        if (response?.access_token) {
          authContext.login(response.access_token, response.refresh_token);
          // navigate("/dashboard");
        } else {
          console.error("Tokens not received");
          navigate("/auth/login");
        }
      } catch (err) {
        console.error("OAuth callback error:", err.message);
        navigate("/auth/login");
      }
    };

    handleCallback();
  }, [location, provider, authContext, navigate]);

  return <div>Processing OAuth login...</div>;
}

export default OAuthCallback;
